import { createSelector } from '@reduxjs/toolkit'
import { RootState } from 'app/store/store'
import { IStepTwo } from './types/step-two-inerface'

const StepTwoState = (state: RootState): IStepTwo => state.stepTwo

export const StepTwoFields = createSelector(
    [StepTwoState],
    (state): IStepTwo => state,
)